export function getBetweenSizesWarning(result, neighbors, t) {
  if (!result?.row || !neighbors?.smaller || !neighbors?.larger) return null;

  const systemId = result.inputSystem;
  const smallerVal = neighbors.smaller[systemId];
  const largerVal = neighbors.larger[systemId];
  if (!smallerVal || !largerVal) return null;

  if (result.matchedByMeasurement) {
    const inputCm = parseFloat(result.inputValue);
    const low = parseFloat(neighbors.smaller.cm);
    const high = parseFloat(neighbors.larger.cm);
    if (!Number.isNaN(inputCm) && !Number.isNaN(low) && !Number.isNaN(high)) {
      const mid = (low + high) / 2;
      if (Math.abs(inputCm - mid) <= 0.5) {
        return {
          smallerVal,
          largerVal,
          message: t.betweenSizes.measurement,
        };
      }
    }
  }

  return null;
}

export function getMatchConfidence(result) {
  if (!result?.row) return null;
  if (!result.matchedByMeasurement) return { level: 'high', labelKey: 'exact' };
  const diff = result.measurementDiff;
  if (diff == null) return { level: 'medium', labelKey: 'close' };
  if (diff <= 0.5) return { level: 'high', labelKey: 'close' };
  if (diff <= 1.5) return { level: 'medium', labelKey: 'estimate' };
  return { level: 'low', labelKey: 'estimate' };
}
